import React, { useState } from "react";
import i18n from "../i18n";
import Select from "../parts/inputs/select";

const LANGUAGE_OPTIONS = [
  { text: "English", value: "en" },
  { text: "Español", value: "es" },
];

const LoginWrapper = ({ left, right, mainClass = "Login" }) => {
  const [selectedLanguage, setSelectedLanguage] = useState(
    i18n.language || "en"
  );

  const handleLanguageChange = (newVal) => {
    i18n.changeLanguage(newVal);
    setSelectedLanguage(newVal);
  };

  return (
    <main className={mainClass} role="login-wrapper">
      <section>{left}</section>

      <aside>{right ? right : <img className="msb-powered-logo" />}</aside>
      <div className="fixed top-6 right-6">
        <Select
          options={LANGUAGE_OPTIONS}
          value={selectedLanguage}
          onChange={handleLanguageChange}
        />
      </div>
    </main>
  );
};

export default LoginWrapper;
